"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllLocationsByZip = void 0;
/**
 * Fetch all possible location information from a zip code
 *
 * @public
 *
 * @typeParam T The type of the repository that should be derived from {@link ILocationRepository}
 *
 * @param repository The repository instance to handle location. See {@link locationRepository}
 * @param zip A valid zip code
 *
 * @returns An async array of possible zip code matches. If there are no matches then an empty array is returned
 *
 * @example
 * ```ts
 * const location = await fetchAllLocationByZip(locationRepository, '3133'); // Array
 * ```
 */
async function fetchAllLocationsByZip(repository, zip) {
    try {
        return repository.fetchAllLocationsByZip(zip);
    }
    catch (error) {
        // TODO: add raygun notification
        return null;
    }
}
exports.fetchAllLocationsByZip = fetchAllLocationsByZip;
//# sourceMappingURL=fetch-location-by-zip.js.map